import CheckCircleIcon from '@mui/icons-material/CheckCircle'
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useContract } from '../../../hooks/useContract'

export const InvoiceTypeInfo = () => {
	const { t } = useTranslation('pages_invoices')
	const { contractData, isContractLoading } = useContract()

	if (isContractLoading || !contractData) {
		return null
	}

	const eInvoiceActive = !!contractData.EInvoicingAddress && contractData.Status === 'Active'

	if (eInvoiceActive) {
		return (
			<div className='flex items-start gap-2 rounded-2xl p-4 mb-4 bg-[#cae3cc] dark:bg-[#0d2d30]'>
				<CheckCircleIcon className='text-[#127d27] dark:text-[#3cb49f] shrink-0' />
				<div className='flex flex-col text-text-dark dark:text-white'>
					<span className='font-semibold'>{t('eInvoice.activeTitle')}</span>
					<span className='text-text-grey-300 dark:text-text-grey-100 text-sm'>
						{t('eInvoice.activeDetails', {
							bank: contractData.EInvoicingAddress?.Bank,
						})}
					</span>
				</div>
			</div>
		)
	}

	return (
		<div className='flex items-start gap-2 rounded-2xl p-4 mb-4 bg-[#f5f5f5] dark:bg-[#0d2d30]'>
			<InfoOutlinedIcon className='text-text-grey-200 dark:text-text-grey-100 shrink-0' />
			<div className='flex flex-col text-text-dark dark:text-white'>
				<span className='font-semibold'>{t('eInvoice.nudgeTitle')}</span>
				<span className='text-text-grey-300 dark:text-text-grey-100 text-sm'>
					{t('eInvoice.nudgeDetails')}
				</span>
			</div>
		</div>
	)
}

export default InvoiceTypeInfo
